// import React, { useEffect, useRef, useState } from "react";
// import "./CourseStyle.css";
// import { Link } from "react-router-dom";
// import { COURSE_BASE_URL } from "../../services/courseService";
// import Loading from "../../utils/Loading";
// import axios from "axios";

// const CourseList = () => {
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [courses, setCourses] = useState([]);
//   const courseSectionRef = useRef(null);

//   const fetchCourseData = async () => {
//     try {
//       const response = await axios.get(`${COURSE_BASE_URL}/api/courses/list`);
//       const courseData = Array.isArray(response.data) ? response.data : [];
//       setCourses(courseData);
//       setLoading(false);
//     } catch (error) {
//       setError(error);
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchCourseData();
//   }, []);

//   const scrollToCourseSection = () => {
//     courseSectionRef.current.scrollIntoView({ behavior: "smooth" });
//   };
//   return (
//     <div className="courses-list">
//       {/* Start o couse her */}
//       <div className="course-hero d-flex align-items-center bg-dark">
//         <div className="container bg-white py-4 text-center text-dark">
//           <h1 className="display-1">Learn to Code</h1>
//           <p className="lead">
//             Join our community and start your coding journey today!
//           </p>
//           <button
//             className="btn btn-outline-warning btn-lg text-uppercase"
//             onClick={scrollToCourseSection}
//           >
//             Get Started
//           </button>
//         </div>
//       </div>
//       {/* End of o couse her */}

//       {/* start of new contact */}

//       {/* End of new content */}

//       <div className="container  mt-3" id="course" ref={courseSectionRef}>
//         <div className="row">
//           <div className="col">
//             {error && <div className="alert alert-danger">{error.message}</div>}
//             {!loading && !error && courses.length === 0 && (
//               <div className="alert alert-warning mt-4" role="alert">
//                 <p className="text-center lead h5">
//                   New courses are coming soon. Please check back again!
//                 </p>
//               </div>
//             )}
//           </div>
//         </div>
//         <div className="row">
//           <div className="col">
//             {loading && <Loading />}
//             {error && <div className="alert alert-danger">{error.message}</div>}
//           </div>
//         </div>
//         {/*  to={`/api/blogs/blog-details/${
//                         blog._id
//                       }/${blog.title.replace(/\s+/g, "-")}`}*/}
//         <div className="row">
//           {!loading &&
//             !error &&
//             courses.map((course) => (
//               <div className="col-lg-3 col-md-6 col-sm-6" key={course._id}>
//                 <div className="card mb-4">
//                   <Link
//                     // to={`/api/courses/course-details/${course._id}/${course.title}`}
//                     to={`/api/courses/course-details/${
//                       course._id
//                     }/${course.title.replace(/\s+/g, "-")}`}
//                   >
//                     <img
//                       src="https://mdbcdn.b-cdn.net/img/Photos/Horizontal/E-commerce/Products/4.webp"
//                       className="card-img-top w-100"
//                       alt={course.title || ""}
//                     />
//                   </Link>

//                   <div
//                     className="card-body bg-light text-dark"
//                     style={{ minHeight: "200px" }}
//                   >
//                     <div className="d-flex justify-content-between">
//                       <p className="small">
//                         <span className="text-muted">{course.category}</span>{" "}
//                         <hr />
//                       </p>
//                     </div>
//                     <div className="d-flex justify-content-between mb-2">
//                       <Link
//                         className="text-success"
//                         to={`/api/courses/course-details/${
//                           course._id
//                         }/${course.title.replace(/\s+/g, "-")}`}
//                         // to={`/api/courses/course-details/${course._id}`}
//                       >
//                         <p className="mb-0">{course.title}</p>
//                       </Link>

//                       <h4 className="text-dark fw-bold me-2">
//                         {parseFloat(course.price).toLocaleString("en-US", {
//                           style: "currency",
//                           currency: "USD",
//                           minimumFractionDigits: 2,
//                           maximumFractionDigits: 2,
//                         })}
//                       </h4>
//                     </div>

//                     <div className="d-flex justify-content-between mb-2">
//                       <p className="text-muted mb-0">
//                         Available courses:{" "}
//                         <span className="fw-bold">
//                           {course.numberOfCourses}
//                         </span>
//                       </p>
//                       {/* <div className="ms-auto text-warning">
// 												{[...Array(Math.round(course.courseRating))].map(
// 													(_, i) => (
// 														<i key={i} className="fa fa-star" />
// 													)
// 												)}
// 												{[...Array(5 - Math.round(course.courseRating))].map(
// 													(_, i) => (
// 														<i key={i} className="fa fa-star-o" />
// 													)
// 												)}
// 											</div> */}
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CourseList;

import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { COURSE_BASE_URL } from "../../services/courseService";
import Loading from "../../utils/Loading";
import axios from "axios";

const CourseList = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [courses, setCourses] = useState([]);
  const courseSectionRef = useRef(null);

  const fetchCourseData = async () => {
    try {
      const response = await axios.get(`${COURSE_BASE_URL}/api/courses/list`);
      const courseData = Array.isArray(response.data) ? response.data : [];
      setCourses(courseData);
      setLoading(false);
    } catch (error) {
      setError(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCourseData();
  }, []);

  const scrollToCourseSection = (e) => {
    e.preventDefault();
    if (courseSectionRef.current) {
      courseSectionRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <div className="courses-list" style={{ position: "relative" }}>
      {/* Hero Section */}
      <section className="hero-section bg-primary text-white py-5">
        <div className="container py-5">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h1 className="display-3 fw-bold mb-4">
                <i className="fa fa-code me-3"></i>Unlock Your Coding Potential
              </h1>
              <p className="lead mb-4">
                Join thousands of students who have transformed their careers
                with our industry-leading coding courses. Learn from experts and
                build real-world projects.
              </p>
              <div className="d-flex gap-3">
                <a
                  href="#course-section"
                  className="btn btn-light btn-lg px-4 rounded-pill fw-bold"
                  onClick={scrollToCourseSection}
                  style={{
                    cursor: "pointer",
                    position: "relative",
                    zIndex: 10,
                  }}
                >
                  <i className="fa fa-arrow-down me-2"></i>Explore Courses
                </a>
                {/* <Link
                  to="/contact"
                  className="btn btn-outline-light btn-lg px-4 rounded-pill"
                >
                  <i className="fa fa-question-circle me-2"></i>Need Help?
                </Link> */}
              </div>
            </div>
            <div className="col-lg-6 d-none d-lg-block">
              <img
                src="https://images.unsplash.com/photo-1555066931-4365d14bab8c?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
                alt="Coding illustration"
                className="img-fluid rounded shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-5 bg-light">
        <div className="container">
          <div className="row g-4">
            <div className="col-md-4">
              <div className="card h-100 border-0 shadow-sm">
                <div className="card-body text-center p-4">
                  <div className="bg-primary bg-opacity-10 text-primary rounded-circle p-3 d-inline-block mb-3">
                    <i className="fa fa-certificate fa-2x"></i>
                  </div>
                  <h4 className="fw-bold">Industry Recognized</h4>
                  <p className="text-muted">
                    Certificates that boost your resume and LinkedIn profile.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card h-100 border-0 shadow-sm">
                <div className="card-body text-center p-4">
                  <div className="bg-success bg-opacity-10 text-success rounded-circle p-3 d-inline-block mb-3">
                    <i className="fa fa-laptop fa-2x"></i>
                  </div>
                  <h4 className="fw-bold">Hands-on Projects</h4>
                  <p className="text-muted">
                    Learn by building real applications that showcase your
                    skills.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card h-100 border-0 shadow-sm">
                <div className="card-body text-center p-4">
                  <div className="bg-info bg-opacity-10 text-info rounded-circle p-3 d-inline-block mb-3">
                    <i className="fa fa-users fa-2x"></i>
                  </div>
                  <h4 className="fw-bold">Expert Support</h4>
                  <p className="text-muted">
                    Get help from our community of instructors and peers.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Courses Section */}
      <section className="py-5" id="course-section" ref={courseSectionRef}>
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="display-5 fw-bold">Our Featured Courses</h2>
            <p className="lead text-muted">
              Choose from our wide range of programming courses
            </p>
          </div>

          {error && (
            <div className="alert alert-danger text-center">
              <i className="fa fa-exclamation-triangle me-2"></i>
              {error.message}
            </div>
          )}

          {!loading && !error && courses.length === 0 && (
            <div className="alert alert-warning text-center">
              <i className="fa fa-info-circle me-2"></i>
              New courses are coming soon. Please check back again!
            </div>
          )}

          {loading && <Loading />}

          <div className="row g-4">
            {!loading &&
              !error &&
              courses.map((course) => (
                <div className="col-lg-4 col-md-6" key={course._id}>
                  <div className="card h-100 border-0 shadow-sm overflow-hidden">
                    <div className="position-relative">
                      <Link
                        to={`/api/courses/course-details/${
                          course._id
                        }/${course.title.replace(/\s+/g, "-")}`}
                      >
                        <img
                          src={
                            course.imageUrl ||
                            "https://mdbcdn.b-cdn.net/img/Photos/Horizontal/E-commerce/Products/4.webp"
                          }
                          className="card-img-top"
                          alt={course.title}
                          style={{ height: "200px", objectFit: "cover" }}
                        />
                      </Link>
                      <div className="badge bg-primary position-absolute top-0 end-0 m-3">
                        {course.category}
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="d-flex justify-content-between mb-2">
                        <span className="text-muted small">
                          <i className="fa fa-clock-o me-1"></i>{" "}
                          {course.duration || "Self-paced"}
                        </span>
                        <span className="text-muted small">
                          <i className="fa fa-book me-1"></i>{" "}
                          {course.numberOfCourses || 0} lessons
                        </span>
                      </div>
                      <h5 className="card-title fw-bold">
                        <Link
                          to={`/api/courses/course-details/${
                            course._id
                          }/${course.title.replace(/\s+/g, "-")}`}
                          className="text-decoration-none text-inherit"
                        >
                          {course.title}
                        </Link>
                      </h5>
                      <p className="card-text text-muted small">
                        {course.shortDescription ||
                          "Learn this essential skill with hands-on projects and expert guidance."}
                      </p>
                    </div>
                    <div className="card-footer bg-white border-0 d-flex justify-content-between align-items-center">
                      <div className="d-flex align-items-center">
                        <div className="me-2">
                          <i className="fa fa-star text-warning"></i>
                          <i className="fa fa-star text-warning"></i>
                          <i className="fa fa-star text-warning"></i>
                          <i className="fa fa-star text-warning"></i>
                          <i className="fa fa-star-half-o text-warning"></i>
                        </div>
                        <small className="text-muted">(24)</small>
                      </div>
                      <h5 className="text-danger mb-0 fw-bold">
                        {parseFloat(course.price).toLocaleString("en-US", {
                          style: "currency",
                          currency: "USD",
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </h5>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-5 bg-dark text-white">
        <div className="container py-4 text-center">
          <h2 className="display-5 fw-bold mb-4">
            Ready to start your coding journey?
          </h2>
          <p className="lead mb-4">
            Join our community of learners and take the first step towards your
            dream career.
          </p>
          <Link
            to="/api/users/register"
            className="btn btn-primary btn-lg px-4 rounded-pill fw-bold"
          >
            <i className="fa fa-user-plus me-2"></i>Sign Up Now
          </Link>
        </div>
      </section>
    </div>
  );
};

export default CourseList;
